/**
 * en-GB messages added by Phase 3 task K6 (docs/PHASE-3-PLAN.md). Only that task edits this file.
 * Flat keys, `{name}` placeholders, merged into enGB by ./index.ts.
 * Messages come back from the kiosk foundation (lib/p3) as keys; the screens (K7) show them.
 */
export const k6EnGB = {
    'kiosk.evacuation.notAllowed': 'Evacuations cannot be started from this kiosk.',
    'kiosk.evacuation.wrongPin': 'That PIN is not right.',
    'kiosk.evacuation.pinLocked': 'Too many wrong PINs. Please wait a few minutes.',
    'kiosk.evacuation.startFailed': 'The evacuation could not be started. Please try again.',
    'kiosk.nfc.enrolOffline': 'This kiosk is offline. Cards can only be registered while it is online.',
    'kiosk.nfc.enrolExpired': 'This card registration has finished or timed out.',
    'kiosk.nfc.enrolFailed': 'That card could not be registered. Please try another.',
    'kiosk.nfc.enrolTapAgain': 'Please tap the card again.',
};
//# sourceMappingURL=k6.js.map